export enum BookingRouterState {
  Create,
  CreateHome,
  CreateCopy,
  Edit
}